import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {PayPeriodAttributes} from '../../models/models.interfaces';
import {ApiService} from '../../shared/api';

export interface PayValue {
  name: string;
  allValue: number;
  sumValue: number;
  contractId: number;
  payPeriod: PayPeriodAttributes;
  originPayPeriod: PayPeriodAttributes;
}

/**
 * Employees service that expose access to employee information.
 */
@Injectable()
export class PayValuesService {

  constructor(private api: ApiService) {
  }

  /**
   * Get an employee form descriptor for a cliReg.
   *
   * @returns {Observable<FormDescriptor>} an observable that emits the form descriptor as fetched from the
   * server
   * @param contractId
   * @param payPeriodId
   * @param originPayPeriodId
   * @param names
   */
  public getPayValues(contractId: number, payPeriodId: number, originPayPeriodId: number, names: string[]): Observable<PayValue[]> {
    if (names.length === 0) {
      return of([]);
    }

    const nameParams = names.map(name => `name=${name}`).join('&');
    return this.api.get(`/payroll/api/v1/pay-value?contract-id=${contractId}&pay-period-id=${payPeriodId}&origin-pay-period-id=${originPayPeriodId}&${nameParams}`);
  }
}
